module.exports = __webpack_public_path__ + "img/german-fashion.d56c778.png";